// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://lvnorfnsrmngrxptulhk.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx2bm9yZm5zcm1uZ3J4cHR1bGhrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMzNDkyODEsImV4cCI6MjA1ODkyNTI4MX0.lqGDYQXLq-wlHBP9GUoqrdRsc483YxDIzZNJAwIihGE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);